<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    {{ $t("overTime") }}
                  </h4>

                  <button
                    v-if="this.permision_role.method_create"
                    class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="createData()"
                  >
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>
                  <!-- <button
                     v-if="this.permision_role.method_upload"
                    class="btn btn-warning float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="uploadData()"
                  >
                     <i class="link-icon" data-feather="upload"></i>
                    {{ $t("uploadData") }} .xlsx
                  </button> -->
                  <!-- <button
                    v-if="this.permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button> -->

                  
                  <div class="btn-group float-end" style="margin-right: 5px;">
                      <button type="button" class="btn btn-sm btn-success" @click.prevent="downloadData()">
                          <i class="link-icon mdi mdi-download"></i>
                          {{ $t("downloadData") }} .xlsx
                      </button>
                      <button type="button" class="btn btn-success  btn-sm dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click.prevent="downloadForFlux()">Download Data For Flux</a>
                      </div>
                  </div>

                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-3">
                      <div class="mb-3">
                        <label class="form-label">Overtime Date</label>
                        <!-- <input type="text" class="form-control" placeholder="Enter first name"> -->
                        <date-range-picker
                          style="width: 100%"
                          control-container-class="form-control"
                          :locale-data="locale"
                          v-model="overtimeDateFilter"
                          :opens="opens"
                          :showWeekNumbers="false"
                        >
                        </date-range-picker>
                      </div>
                    </div>
                    <div class="col d-flex align-items-center">
                      <button class="btn btn-primary" @click="loadItems()">Search</button>
                    </div>
                  </div>
                  <vue-good-table
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }"
                    :rows="rows"
                    :columns="columns"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a
                          href="#"
                          v-if="permision_role.method_read"
                          title="Detail"
                          @click.prevent="detailData(props.index, props.row)"
                        >
                          <i class="mdi mdi-eye" style="font-size: 16px"></i>
                        </a>
                        <a
                          v-if="
                            permision_role.method_update == true &&
                            props.row.status === 'deactivate'
                          "
                          href="#"
                          title="Click for Activated"
                          @click.prevent="
                            deleteData(props.index, props.row, 'active')
                          "
                        >
                          <i class="mdi mdi-check" style="font-size: 16px"></i>
                        </a>
                        <a
                          href="#"
                          v-if="
                            permision_role.method_update == true &&
                            props.row.status === 'active'
                          "
                          title="Click for Deactive"
                          @click.prevent="
                            deleteData(props.index, props.row, 'deactivate')
                          "
                        >
                          <i class="mdi mdi-close" style="font-size: 16px"></i>
                        </a>
                      </span>
                      <span v-else-if="props.column.field == 'is_actual_overtime'">
                        {{ props.row?.is_actual_overtime ? "Yes" : "No" }}
                      </span>
                      <span v-else-if="props.column.field == 'costs'">
                        {{
                          props.row?.cost ? props.row.cost : 0 | format_number
                        }}
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "UsersIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    const startDate = new Date();// new Date();
    startDate.setDate(startDate.getDate() - 90);
    const endDate = new Date();
    return {
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      overtimeDateFilter: {
        startDate,
        endDate,
      },
      maxToasts: 100,
      company_types: [],
      position: "up right",
      closeBtn: true,
      isLoading: false,
      permision_role: [],
      errors: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("warehouseId_txt"),
          field: "warehouse_id",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("warehouseId_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("customerId_txt"),
          field: "customer_id",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("customerId_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("employeeIdTxt"),
          field: "id_employee",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("employeeIdSearchTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("employeeNameTxt"),
          field: "name_employee",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("employeeNameSearchTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("totalWorkDay"),
          field: "amount_of_work_description",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("totalWorkDay"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("overtimeTypeData"),
          field: "type_data",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("overtimeTypeData"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['internal','external'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
         {
          label: this.$t("actualOvertime"),
          field: "is_actual_overtime",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("actualOvertime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [
              {value:0,text:"No"},
              {value:1,text:"Yes"}
            ], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("overtimeType"),
          field: "ot_type_desc",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("overtimeType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("overtimeDateTxt"),
          field: "ot_date",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: this.$t("overtimeDateTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("startOvertime"),
          field: "ot_value_start",
          filterOptions: {
            enabled: false, // enable filter for this column
          },
        },
        {
          label: this.$t("endOvertime"),
          field: "ot_value_end",
          filterOptions: {
            enabled: false, // enable filter for this column
          },
        },
        {
          label: this.$t("breakTime"),
          field: "break_value",
          filterOptions: {
            enabled: false, // enable filter for this column
          },
        },
        {
          label: this.$t("totalHourOt"),
          field: "total_value",
          filterOptions: {
            enabled: false, // enable filter for this column
          },
        },
        {
          label: "Index",
          field: "index_overtime",
          filterOptions: {
            enabled: false, // enable filter for this column
          },
        },
        {
          label: "Cost",
          field: "costs",
          filterOptions: {
            enabled: false, // enable filter for this column
          },
        },
        // {
        //   label: "Status",
        //   field: "status",
        //   filterOptions: {
        //     enabled: true, // enable filter for this column
        //     placeholder: this.$t("status_filter_txt"), // placeholder for filter input
        //     filterValue: "", // initial populated value for this filter
        //     filterDropdownItems: ["active", "deactived"], // dropdown (with selected values) instead of text input
        //     trigger: "enter", //only trigger on enter not on keyup
        //   },
        // },
        {
          label: this.$t("action_txt"),
          field: "actions",
          sortable: false,
        },
      ],
      rows: [],
    };
  },
  watch: {},
  methods: {
    uploadData() {
      window.location.href = "/user-access/upload";
    },

    downloadData() {
      const baseURI = this.$settings.endpointWhMonitoring + "v1/overtime/index";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";
      let otDateFilter = this.$moment(this.overtimeDateFilter.startDate).format(
        "YYYY-MM-DD"
      )+"~"+this.$moment(this.overtimeDateFilter.endDate).format("YYYY-MM-DD");
      return this.$http
        .get(
          baseURI +
            // `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouse_id=${this.serverParams.columnFilters.warehouse_id}&customer_id=${this.serverParams.columnFilters.customer_id}&id_employee=${this.serverParams.columnFilters.id_employee}&name_employee=${this.serverParams.columnFilters.name_employee}&amount_of_work_description=${this.serverParams.columnFilters.amount_of_work_description}&ot_type_desc=${this.serverParams.columnFilters.ot_type_desc}&ot_date=${this.serverParams.columnFilters.ot_date}&download=download`,
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&`+this.$addFunction.getQueryParam(this.serverParams.columnFilters)+`&ot_date=${otDateFilter}&status=active&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
     downloadForFlux() {
      const baseURI = this.$settings.endpointWhMonitoring + "v1/overtime/index";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_flux_" + CurrentDate + ".xlsx";

      let otDateFilter = this.$moment(this.overtimeDateFilter.startDate).format(
        "YYYY-MM-DD"
      )+"~"+this.$moment(this.overtimeDateFilter.endDate).format("YYYY-MM-DD");

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&`+this.$addFunction.getQueryParam(this.serverParams.columnFilters)+`&ot_date=${otDateFilter}&status=active&download=downloadWms`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    createData() {
      window.location.href = "/wh-monitoring/overtime/create";
    },

    editData(index, row) {
      var params = this.$onRandom(row.overtime_id);
      window.location.href = "/wh-monitoring/overtime/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.overtime_id);
      window.location.href = "/wh-monitoring/overtime/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: status,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endpointWhMonitoring +
            "v1/overtime/update-status/" +
            row.overtime_id;
          this.$http
            .patch(baseURI, formData, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endpointWhMonitoring + "v1/overtime/index";
      let otDateFilter = this.$moment(this.overtimeDateFilter.startDate).format(
        "YYYY-MM-DD"
      )+"~"+this.$moment(this.overtimeDateFilter.endDate).format("YYYY-MM-DD");
      this.isLoading = true;
      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&`+this.$addFunction.getQueryParam(this.serverParams.columnFilters)+`&ot_date=${otDateFilter}&status=active`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller == "WhMonitoringOvertimeController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      var status = this.$route.query.status;
      if (status == "200") {
        this.success(this.$route.query.msg);
      }
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped></style>
